"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getDataOrAriaProps;

function getDataOrAriaProps(props) {
  return Object.keys(props).reduce(function (prev, key) {
    if ((key.substr(0, 5) === 'data-' || key.substr(0, 5) === 'aria-' || key === 'role') && key.substr(0, 7) !== 'data-__') {
      prev[key] = props[key];
    }

    return prev;
  }, {});
}
//# sourceMappingURL=getDataOrAriaProps.js.map



//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/_util/getDataOrAriaProps.js
// module id = 417
// module chunks = 0